import { FC, useState } from 'react';
import { List } from '../types';
import { ModalContext } from './ModalContext';

export const ModalContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [listToDelete, showDeletionModal] = useState<List | null>(null);
  const hideModal = () => {
    showDeletionModal(null);
  };

  return (
    <ModalContext.Provider value={{ listToDelete, showDeletionModal, hideModal }}>
      {children}
    </ModalContext.Provider>
  );
};
